var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineType20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 1.85718,
    x2: 1.60949,
    y2: 1.85718,
    stroke: "#222627"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.48169,
    y1: 1.85718,
    x2: 4.59118,
    y2: 1.85718,
    stroke: "#222627"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.46362,
    y1: 1.85718,
    x2: 7.57311,
    y2: 1.85718,
    stroke: "#222627"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 9.44531,
    y1: 1.85718,
    x2: 10.5548,
    y2: 1.85718,
    stroke: "#222627"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 12.427,
    y1: 1.85718,
    x2: 13.5365,
    y2: 1.85718,
    stroke: "#222627"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 15.4087,
    y1: 1.85718,
    x2: 16.5182,
    y2: 1.85718,
    stroke: "#222627"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 18.3906,
    y1: 1.85718,
    x2: 19.5001,
    y2: 1.85718,
    stroke: "#222627"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 6.03137,
    x2: 4.0361,
    y2: 6.03137,
    stroke: "#222627"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 0.500732,
    y1: 14.0314,
    x2: 4.03683,
    y2: 14.0314,
    stroke: "#222627"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 8.34253,
    y1: 17.7814,
    x2: 11.5894,
    y2: 17.7814,
    stroke: "#222627"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 15.9641,
    y1: 14.0314,
    x2: 19.5002,
    y2: 14.0314,
    stroke: "#222627"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 5.65527,
    y1: 14.0314,
    x2: 14.3462,
    y2: 14.0314,
    stroke: "#222627"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 0.500732,
    y1: 17.7814,
    x2: 6.85639,
    y2: 17.7814,
    stroke: "#222627"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 13.1445,
    y1: 17.7814,
    x2: 19.5002,
    y2: 17.7814,
    stroke: "#222627"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 10,
    x2: 19.5,
    y2: 10,
    stroke: "#222627"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 5.65454,
    y1: 6.03137,
    x2: 9.19064,
    y2: 6.03137,
    stroke: "#222627"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 10.8093,
    y1: 6.03137,
    x2: 14.3454,
    y2: 6.03137,
    stroke: "#222627"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 15.9639,
    y1: 6.03137,
    x2: 19.5,
    y2: 6.03137,
    stroke: "#222627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineType20);
export default __webpack_public_path__ + "static/media/line-type_20.bd8871901d06fadf975a44778b9aa941.svg";
export { ForwardRef as ReactComponent };